export default __webpack_public_path__ + "static/media/Star.ae39c920.svg";